var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.91637V12H7.08362L13.2317 5.8519L11.1481 3.76828L5 9.91637Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8375 3.45992L13.5401 2.16252C13.3234 1.94583 12.9706 1.94583 12.7539 2.16252L11.7371 3.17933L13.8207 5.26295L14.8375 4.24614C15.0542 4.02945 15.0542 3.67661 14.8375 3.45992Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1H2C1.44772 1 1 1.44772 1 2V15C1 15.5523 1.44772 16 2 16H15C15.5523 16 16 15.5523 16 15V12H14.9V14.9H2.1V2.1H6V1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/Application.9f16117d.svg";
export { ForwardRef as ReactComponent };